import {
	DEFAULT_SEASON_ID,
	AWD_SUPPORTED_SEASON_IDS,
} from 'modules/AwdMapView/constants';
import { AWD_SEASONS_ID_MAP } from 'modules/AwdMapView/seasonIdsMap';
import { AWD_SEASONS_CONFIG } from 'modules/AwdMapView/seasonsConfig';
import { getSupportedSeasonIdsByType } from 'modules/CommonView/constants';
import { getSeasonIdMapByType } from 'modules/CommonView/seasonIdsMap';
import { getConfigByType } from 'modules/CommonView/seasonsConfig';
import { SUGARCANE_SUPPORTED_SEASON_IDS } from 'modules/SugarcaneMapView/constants';
import { SUGARCANE_SEASON_ID_MAP } from 'modules/SugarcaneMapView/seasonIdsMap';
import { SUGARCANE_SEASON_CONFIG } from 'modules/SugarcaneMapView/seasonsConfig';
import { useAppSelector } from 'store/hooks';

const useSeasonalConfigs: any = () => {
	const eventType = useAppSelector((s) => s.router.location.query.type);
	const CURRENT_CONFIG = getConfigByType(eventType);
	const CURRENT_SEASONSID_MAP = getSeasonIdMapByType(eventType);
	const CURRENT_SUPPORT_SEASONSID_MAP =
		getSupportedSeasonIdsByType(eventType);
	let seasonId =
		useAppSelector((s) => s.router.location.query.seasonId) ??
		DEFAULT_SEASON_ID;

	const allAppsSupportedSeasonIds = [
		...AWD_SUPPORTED_SEASON_IDS,
		...SUGARCANE_SUPPORTED_SEASON_IDS,
		...CURRENT_SUPPORT_SEASONSID_MAP,
	];

	seasonId = allAppsSupportedSeasonIds.includes(seasonId)
		? seasonId
		: DEFAULT_SEASON_ID;

	const allAppsSeasonsIdMap: any = {
		...AWD_SEASONS_ID_MAP,
		...SUGARCANE_SEASON_ID_MAP,
		...CURRENT_SEASONSID_MAP,
	};

	const allAppsSeasonsConfigs: any = {
		...AWD_SEASONS_CONFIG,
		...SUGARCANE_SEASON_CONFIG,
		...CURRENT_CONFIG,
	};

	const seasonKey = allAppsSeasonsIdMap[seasonId];
	return [allAppsSeasonsConfigs[seasonKey], seasonId, seasonKey];
	// const {
	// 	dataLayers,
	// 	suggestionLayers,
	// 	filters,
	// 	geofenceStatusPropertyKey,
	// 	geofenceRejectionReasonsPropertyKey,
	// 	parentPointPropertyKey,
	// 	portalLockPropertyKey,
	// 	programNames,
	// } = seasonsConfig[seasonKey];
};

export default useSeasonalConfigs;
